import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home } from "../../pages/Home";
import { Contacts } from "../../pages/Contacts";
import { Portfolio } from "../../pages/Portfolio";
import { Project } from "../../pages/Project";
import { Services } from "../../pages/Services/Services";
import { BackendDevelopment } from "../../pages/Services/BackendDevelopment";
import { UX } from "../../pages/UX";
import { ApiProvider } from "./ApiProvider";
import { FrontendDevelopment } from "../../pages/Services/FrontendDevelopment";
import { ApplicationsPage } from "../../pages/Services/Applications";

export function Routing() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    document.activeElement instanceof HTMLElement &&
      document.activeElement.blur();
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return (
    <ApiProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/backend" element={<BackendDevelopment />} />
        <Route path="/services/frontend" element={<FrontendDevelopment />} />
        <Route
          path="/services/web-applications"
          element={<ApplicationsPage />}
        />
        <Route path="/services/design" element={<UX />} />
        <Route path="/portfolio/:projectURL" element={<Project />} />
      </Routes>
    </ApiProvider>
  );
}
